namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    import IFilterService = ng.IFilterService;
    import IUser = app.autenticacao.IUser;
    
    export class AssigneeController {
        
        public assignee: IUser;
        public filterBySetor: boolean = true; 
        public cmd: AssigneeTasksCommand = new AssigneeTasksCommand();
        
        /** @ngInject **/
        public constructor(
            private $mdDialog: IDialogService,
            private $filter: IFilterService,
            private minhasTarefasService: MinhasTarefasService,
            private tasks: ITask[], private users: IUser[],
            private resources: IResource[]) {

            this.cmd.addTasks(tasks);
        }

        public assignTasks(): void {
            this.minhasTarefasService.assignTasks(this.cmd)
                .then(() => {
                    this.tasks.forEach((task) => {
                        task.selected = false;

                        // essa linha abaixo dá a ilusão de atualização pelo evento "task:assigned".
                        // É por isso que algumas propriedades das tarefas (claim_date) não mudam quando
                        // há mudança de assignee na tela de tarefas
                        task.assignee = this.cmd.assignee;
                    });
                    this.$mdDialog.hide();
                });
        }
        
        public changeAssignee(): void {
            if (this.assignee) {
                this.cmd.assignee = this.assignee.login;
            } else {
                this.cmd.assignee = null;
            }
        }

        public changeFilterBySetor(): void {
            this.minhasTarefasService.listUsersByResources(this.resources, this.filterBySetor)
                .then(users => {
                    this.users.splice(0, this.users.length);
                    this.users.push(...users);
                });            
        }

        public closeDialog(): void {
            this.$mdDialog.hide();
        }
        
        public filterUsers(searchText: string): Array<IUser> {
            const accentInsensitiveOrderBy = this.$filter("accentInsensitiveOrderBy");
            const accentInsensitiveFilter = this.$filter("accentInsensitiveFilter");
            return accentInsensitiveOrderBy(accentInsensitiveFilter(this.users, searchText), "value");
        }
        
    }
    
    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.AssigneeController", AssigneeController);
}
